import { Modal } from 'framework/ui/ui-builder';
import ExternalReportForm from './ExternalReportForm';
import { ModalForm } from 'framework/form';
import { useProjectDetails } from '../../dashboard/hooks/useProjectDashboard';
import useCustomerReportService from '../useCustomerReportService';

interface ExternalReportModalProps {
  externalModalOpen: boolean;
  setExternalModalOpen: (data: boolean) => void;
  id: string;
}

const ExternalReportModal = ({ externalModalOpen, setExternalModalOpen, id }: ExternalReportModalProps) => {
  const { saveExternalReport, contentReportSearch, getExternalReportValidationSchema } = useCustomerReportService();
  const { refetch } = useProjectDetails(id);

  return (
    <Modal title="Add new customer report" isOpen={externalModalOpen} onToggle={() => setExternalModalOpen(false)}>
      <ModalForm
        closeModal={() => setExternalModalOpen(false)}
        modalOpen={externalModalOpen}
        getValidationSchemaFunc={getExternalReportValidationSchema}
        getDataFunc={() => contentReportSearch(id!, false, {})}
        submitFormFunc={async values =>
          saveExternalReport(id!, {
            periodStart: values.periodStart,
            periodEnd: values.periodEnd,
            projectId: id,
            externalReportLink: values.externalReportLink,
          })
        }
        afterSubmit={{
          execute: refetch,
          message: 'You are awesome! External customer report has been successfully created.',
        }}
      >
        <ExternalReportForm />
      </ModalForm>
    </Modal>
  );
};
export default ExternalReportModal;
